<template>
    <div class="step step-4 flex flex-col items-center w-full top-0 bottom-0">
        <h2 class="subtitle white text-center mt-5">
            {{ $trans.get("deposits.step-4-subtitle") }}
        </h2>

        <div
            class="content flex flex-col self-stretch space-y-6 lg:flex-row lg:space-x-16 lg:space-y-0 xl:space-x-32"
        >
            <section class="form-section w-full">
                <h3 class="mb-6 lg:mb-12">
                    {{ $trans.get("deposits.personal-data") }}
                </h3>
                <form class="w-full">
                    <form-data-component>
                        <province-school-component on-deposits-page />
                    </form-data-component>
                </form>
            </section>

            <section class="summary w-full">
                <h3 class="self-start mb-6 lg:mb-12">
                    {{ $trans.get("deposits.summary") }}
                </h3>
                <div class="summary-box details bg-white w-full flex flex-col">
                    <div class="summary-box-top pb-8">
                        <p>
                            {{ titleSelected }}
                        </p>
                        <ul>
                            <li
                                class="flex justify-between mb-3"
                                v-if="
                                    ['title', 'title+taxes'].includes(
                                        getFormData.purpose
                                    )
                                "
                            >
                                <div>
                                    <span
                                        class="material-icons material-icons-circle pr-3"
                                    >
                                        circle
                                    </span>
                                    <p class="inline">
                                        {{
                                            $trans.get(
                                                "deposits.step-2-options.title"
                                            )
                                        }}
                                    </p>
                                </div>
                                <span>{{ getFormData.titleAmount }}€</span>
                            </li>
                            <li
                                class="flex justify-between mb-3"
                                v-if="
                                    ['taxes', 'title+taxes'].includes(
                                        getFormData.purpose
                                    )
                                "
                            >
                                <div>
                                    <span
                                        class="material-icons material-icons-circle pr-3"
                                    >
                                        circle
                                    </span>
                                    <p class="inline">
                                        {{
                                            $trans.get(
                                                "deposits.step-2-options.taxes"
                                            )
                                        }}
                                    </p>
                                </div>
                                <span>{{ getFormData.taxesAmount }}€</span>
                            </li>
                        </ul>
                        <p class="total flex justify-between mt-5 mb-0">
                            <span>Total</span>
                            <span>{{ total | currency }}</span>
                        </p>
                    </div>
                    <div
                        class="summary-box-bottom flex flex-col items-center pt-5"
                    >
                        <p class="payment-methods">
                            {{ $trans.get("deposits.payment-methods") }}
                        </p>
                        <div class="cards flex space-x-2">
                            <img src="/img/icons/visa.svg" />
                            <img src="/img/icons/mastercard.svg" />
                            <img src="/img/icons/maestro.png" />
                            <img
                                class="pl-1"
                                src="/img/icons/american-express.png"
                            />
                        </div>
                        <v-btn
                            @click="saveData()"
                            :disabled="!validForm"
                            class="mdc-button do-pay mdc-button--unelevated mdc-ripple-upgraded unelevated w-full self-stretch"
                        >
                            <span class="mdc-button__label">{{
                                $trans.get("deposits.pay")
                            }}</span>
                        </v-btn>
                    </div>
                    <form
                        id="paymentForm"
                        name="frm"
                        class="flex"
                        :action="action"
                        method="POST"
                    >
                        <input
                            type="hidden"
                            name="Ds_SignatureVersion"
                            v-model="version"
                        />
                        <input
                            type="hidden"
                            name="Ds_MerchantParameters"
                            v-model="params"
                        />
                        <input
                            type="hidden"
                            name="Ds_Signature"
                            v-model="signature"
                        />
                    </form>
                </div>
                <!-- <a href="#" class="block text-center mt-8">{{
                    $trans.get("deposits.doubts")
                }}</a>
                <a href="#" class="block text-center mt-1">{{
                    $trans.get("deposits.info")
                }}</a> -->
            </section>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { MDCTextField } from "@material/textfield";
import { snakeCase } from "snake-case";
import { mapGetters } from "vuex";

export default {
    props: {
        titleSelected: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            params: "",
            signature: "",
            version: "",
            idOrder: ""
        };
    },

    computed: {
        ...mapGetters(["getFormData", "validForm"]),
        total() {
            return Number(
                (
                    (this.formatAmount(this.getFormData.titleAmount) || 0 ) +
                    (this.formatAmount(this.getFormData.taxesAmount) || 0)
                ).toFixed(2)
            );
        },
        action() {
            return window.redsysUrl;
        }
    },

    filters: {
        currency: function(value) {
            return value.toString().replace(".", ",") + "€";
        }
    },

    methods: {
        formatAmount(amount) {
            if (!amount) return null;
            return Number(amount.replace(",", "."));
        },
        retrievePaymentParameters() {
            axios
                .get("/api/payment", {
                    params: {
                        amount: this.total
                    }
                })
                .then(res => {
                    this.params = res.data["params"];
                    this.signature = res.data["signature"];
                    this.version = res.data["version"];
                    this.idOrder = res.data["idOrder"];
                })
                .catch(err => {
                    console.log(err);
                });
        },
        saveData() {
            let params = {
                ...this.getFormData,
                amount: this.total,
                titleAmount: this.formatAmount(this.getFormData.titleAmount),
                taxesAmount: this.formatAmount(this.getFormData.taxesAmount),
                idOrder: this.idOrder,
            };
            for (const key of ['dateOfBirth', 'postalCode', 'titleType', 'titleId', 'titleAmount', 'taxesAmount']) {
                const newKey = snakeCase(key);
                params[newKey] = params[key];
                delete params[key];
            }

            axios
                .get("/dataForm", { params })
                .then(res => {
                    document.getElementById("paymentForm").submit();
                    console.log(res);
                })
                .catch(err => {
                    alert(
                        this.lang === "es"
                            ? "Ha habido un problema con los datos"
                            : "Hi ha hagut un error amb les dades"
                    );
                    console.log(err);
                });
        }
    },

    created() {
        this.retrievePaymentParameters();
        this.lang = window.appLocale;
    },

    mounted() {
        [].map.call(this.$el.querySelectorAll(".mdc-text-field"), function(el) {
            new MDCTextField(el);
        });
    }
};
</script>

<style scoped lang="scss">
.step-4 {
    @media (max-width: 1023px) {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
    }
}

h3 {
    font-size: 20px;
    line-height: 1.5;
}

.summary-box {
    padding: 30px 14.5px 26px 18px;
    border-radius: 6px;
    background-color: #ffffff;
    color: black;
    font-size: 15px;

    .summary-box-top {
        border-bottom: 1px solid #4d4d4d;

        .material-icons-circle {
            font-size: 6px;
        }

        .total span {
            font-size: 16px;
            font-weight: bold;
        }
    }

    .summary-box-bottom {
        .payment-methods {
            font-size: 12px;
        }

        .cards img {
            height: 34px;
        }

        .mdc-button {
            margin-top: 2.5rem;
        }
    }
}
</style>
